import { Asterisk } from "lucide-react";

const ITEMS = ["Grab Rails", "Hand Rails", "Rubber Ramps", "Supplied & Installed", "Perth, WA", "We Care"];

function Row({ hidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-display text-sm font-bold uppercase tracking-[0.3em] text-ivory/85 sm:px-10 sm:text-base">
            {item}
          </span>
          <Asterisk className="h-4 w-4 shrink-0 text-sage-tint" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="marquee" className="overflow-hidden border-y border-white/10 bg-charcoal py-4">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
